module.exports = __webpack_public_path__ + "staticcomp/img/share.ba86c24.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/12/share.jpg
// module id = OQQZ
// module chunks = 39